import { SliderMock } from '@features/Basic/ui/Products/types'

import slide251 from 'assets/house/sloder/25/slide2.webp'
import slide252 from 'assets/house/sloder/25/slide5.webp'
import slide253 from 'assets/house/sloder/25/slide3.webp'
import slide254 from 'assets/house/sloder/25/slide4.webp'
import slide255 from 'assets/house/sloder/25/slide1.webp'

import slide401 from 'assets/house/sloder/40/slide2.webp'
import slide402 from 'assets/house/sloder/40/slide5.webp'
import slide403 from 'assets/house/sloder/40/slide3.webp'
import slide404 from 'assets/house/sloder/40/slide4.webp'
import slide405 from 'assets/house/sloder/40/slide1.webp'

import slide651 from 'assets/house/sloder/65/slide6.webp'
import slide652 from 'assets/house/sloder/65/slide5.webp'
import slide653 from 'assets/house/sloder/65/slide3.webp'
import slide654 from 'assets/house/sloder/65/slide4.webp'
import slide656 from 'assets/house/sloder/65/slide2.webp'
import slide655 from 'assets/house/sloder/65/slide1.webp'

import slide902 from 'assets/house/sloder/90/slide5.webp'
import slide903 from 'assets/house/sloder/90/slide3.webp'
import slide904 from 'assets/house/sloder/90/slide4.webp'
import slide901 from 'assets/house/sloder/90/slide2.webp'
import slide905 from 'assets/house/sloder/90/slide1.webp'

import slide1252 from 'assets/house/sloder/125/slide5.webp'
import slide1253 from 'assets/house/sloder/125/slide3.webp'
import slide1254 from 'assets/house/sloder/125/slide4.webp'
import slide1251 from 'assets/house/sloder/125/slide2.webp'
import slide1255 from 'assets/house/sloder/125/slide1.webp'

export const slider1: SliderMock = [
  {
    id: 1,
    image: slide251,
    title: 'sdfdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 2,
    image: slide252,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 3,
    image: slide253,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 4,
    image: slide254,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 5,
    image: slide255,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
]

export const slider2: SliderMock = [
  {
    id: 1,
    image: slide401,
    title: 'sdfdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 2,
    image: slide402,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 3,
    image: slide403,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 4,
    image: slide404,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 5,
    image: slide405,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
]

export const slider3: SliderMock = [
  {
    id: 1,
    image: slide651,
    title: 'sdfdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 2,
    image: slide652,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 3,
    image: slide653,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 4,
    image: slide654,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 5,
    image: slide655,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 6,
    image: slide656,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
]

export const slider4: SliderMock = [
  {
    id: 1,
    image: slide901,
    title: 'sdfdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 2,
    image: slide902,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 3,
    image: slide903,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 4,
    image: slide904,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 5,
    image: slide905,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
]

export const slider5: SliderMock = [
  {
    id: 1,
    image: slide1252,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 2,
    image: slide1253,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 3,
    image: slide1254,
    title: 'sdfsdf',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 4,
    image: slide1255,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
  {
    id: 5,
    image: slide1251,
    title: 'noCover',
    description: 'sdfsdf',
    height: 670,
    width: 1240,
  },
]
